const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCambiarfotodeperfil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 187 187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 93.158,
    cy: 93.157,
    r: 93.157,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.53 75.174h12.353v6.443H129.53z",
    style: {
      fill: "#f5dfbb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.155 0C41.707 0 0 41.709 0 93.158c0 51.446 41.707 93.155 93.155 93.155s93.16-41.709 93.16-93.155C186.315 41.71 144.603 0 93.155 0m59.462 133.901c0 5.709-4.698 10.407-10.408 10.407H43.298c-5.71 0-10.408-4.697-10.41-10.407V71.156c.001-5.712 4.701-10.412 10.413-10.411h7.285V45.033c0-3.427 2.82-6.247 6.247-6.247h24.843c3.425 0 6.244 2.819 6.244 6.244v15.715h54.287c5.71 0 10.409 4.7 10.409 10.41V133.9Z",
    style: {
      fill: "#f5dfbb",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.753 74.511c-15.125.001-27.57 12.447-27.57 27.571s12.446 27.571 27.571 27.571 27.571-12.446 27.571-27.571v-.001c-.001-15.125-12.447-27.57-27.572-27.57m0 43.77c-8.885-.002-16.195-7.314-16.195-16.199s7.312-16.199 16.199-16.199c8.886 0 16.198 7.312 16.199 16.198v.005c0 8.884-7.311 16.195-16.195 16.195z",
    style: {
      fill: "#f5dfbb",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCambiarfotodeperfil);
export default __webpack_public_path__ + "static/media/cambiar foto de perfil.47d483716c9e7154df796ad845370802.svg";
export { ForwardRef as ReactComponent };